import { createContext } from 'react'

import { defaultTheme } from './themes/default.theme'
import type { Theme } from './types'

export const ThemeContext = createContext<Theme>(defaultTheme)
